import InputToggle from '@/_vue/components/ui/input-toggle';
import Stores from '@/_vue/components/stores/index';

export default {
    InputToggle,
    Stores,
};
